export default __webpack_public_path__ + "static/media/section-about.232c73ce.png";